import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';

import validate from './validations';

import Button from '../../components/Button';
import TwoGroup from '../../components/TwoGroup';

import { LoadingSpinner } from '../../components/LoadingSpinner';

import { copyFor, capitalization } from '../../copy/copy';

const Thanks = styled.div`
    font-weight: bold;
    margin-top: 10px;
`;

const SubscribeFormContainer = styled.form`
    position: relative;
    margin-top: -10px;

    > div {
        display: inline-block;
        width: 100%;
        flex: auto;
        display: flex;
        align-items: center;

        > div {
            width: calc(60% - 0.5em);
            display: inline-block;
            flex: auto;

            @media (max-width: 30em) {
                width: 50%;
            }

            div {
                margin-right: 0 !important;
            }

            input {
                width: 100%;
            }
        }

        button {
            height: 36px;
            width: 30%;
            padding: 0 1em;
            text-indent: ${props => (props.isEmailSubmitting ? '-99999px' : '0')};

            @media (max-width: 30em) {
                width: 100%;
            }

            &:focus {
                outline: none;
            }

            + div {
                position: absolute;
                top: 10px;
                right: 14%;
                margin-right: -11px;
                width: 22px !important;
                height: 22px !important;
                display: ${props => (props.isEmailSubmitting ? 'block' : 'none')};

                @media (max-width: 30em) {
                    top: auto;
                    margin-left: 0 !important;
                }
            }
        }
    }
`;

const SubscribeForm = props => (
    <SubscribeFormContainer
        onSubmit={props.handleSubmit}
        autocomplete="on"
        isEmailSubmitting={props.isEmailSubmitting}
    >
        {props.isEmailSubmitted ? (
            <Thanks>{copyFor('overlay', 'signupFeedback')}</Thanks>
        ) : (
            <TwoGroup>
                <Field
                    className={'fs-block'}
                    name="email"
                    component={InputGroup}
                    type="email"
                    label="Email"
                    placeholder={copyFor(
                        'placeholders',
                        'emailAddress',
                        null,
                        capitalization.eachWord
                    )}
                />
                <Button
                    primary={true}
                    label={copyFor('buttons', 'submit', null, capitalization.eachWord)}
                    type="submit"
                    className="submitButton"
                    disabled={props.invalid}
                />
                <LoadingSpinner
                    style={{
                        top: `18px`,
                        right: `25%`,
                        transform: `translateX(25%)`
                    }}
                    className="ie-small-submit-button-loading-spinner"
                />
            </TwoGroup>
        )}
    </SubscribeFormContainer>
);

SubscribeForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    isEmailSubmitting: PropTypes.bool,
    isEmailSubmitted: PropTypes.bool,
    invalid: PropTypes.bool.isRequired
};

export default compose(
    connect(state => {
        return {
            initialValues: {
                email: state.cachedFormData.email || ''
            }
        };
    }),
    reduxForm({
        form: 'subscribeDetailsForm',
        validate,
        destroyOnUnmount: false
    })
)(SubscribeForm);
